var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter_alt_black_24dp 1",
    clipPath: "url(#clip0_13098_11720)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.54157 4.67516C5.2249 6.8335 8.33324 10.8335 8.33324 10.8335V15.8335C8.33324 16.2918 8.70824 16.6668 9.16657 16.6668H10.8332C11.2916 16.6668 11.6666 16.2918 11.6666 15.8335V10.8335C11.6666 10.8335 14.7666 6.8335 16.4499 4.67516C16.8749 4.12516 16.4832 3.3335 15.7916 3.3335H4.1999C3.50824 3.3335 3.11657 4.12516 3.54157 4.67516Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13098_11720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterM);
export default __webpack_public_path__ + "static/media/filter-m.e623c6ac3491378c11305d048212440d.svg";
export { ForwardRef as ReactComponent };